const AUTH0_ERROR_FIELDS = [
  'error',
  'error_description',
  'errorDescription',
  'description',
  'message'
] as const;
const DISABLED_CONNECTION_ERROR_PATTERN =
  /(?=.*\bconnection\b)(?=.*\bdisabled\b)/;
const AUTH0_SSO_DATA_STORAGE_KEY = 'auth0.ssodata'; // set in the localStorage by the Auth0 SDK for SSO data

export { AUTH0_SSO_DATA_STORAGE_KEY };

export function isAuth0ConnectionDisabledError(error: unknown): boolean {
  const errorMessages: string[] = getAuth0ErrorMessages(error);

  return errorMessages.some((errorMessage: string) => {
    const normalizedErrorMessage: string = errorMessage
      .toLowerCase()
      .replace(/[_-]/g, ' ');

    return DISABLED_CONNECTION_ERROR_PATTERN.test(normalizedErrorMessage);
  });
}

function getAuth0ErrorMessages(error: unknown): string[] {
  if (typeof error === 'string') {
    return [error];
  }

  if (!error || typeof error !== 'object') {
    return [];
  }

  const errorObject: Record<string, unknown> = error as Record<string, unknown>;

  return AUTH0_ERROR_FIELDS.map((fieldName: string): unknown => {
    return errorObject[fieldName];
  }).filter((fieldValue: unknown): fieldValue is string => {
    return typeof fieldValue === 'string';
  });
}

export function clearAuth0SsoData(
  storage: Storage = window.localStorage
): void {
  storage.removeItem(AUTH0_SSO_DATA_STORAGE_KEY);
}
